export default __webpack_public_path__ + "static/media/expRed.1bdca5f9.svg";